/* article */
const commentCountSchema = {
    $id: '$root',
    type: 'object',
    title: '评论数据',
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        doc_url: {
            $id: '$root/properties/doc_url',
            type: 'string',
        },
        join_count: {
            $id: '$root/properties/join_count',
            type: 'integer',
        },
        count: {
            $id: '$root/properties/count',
            type: 'integer',
        },
        allcount: {
            $id: '$root/properties/allcount',
            type: 'integer',
        },
    },
};

const voteNumSchema = {
    $id: '$root',
    type: 'object',
    title: '文章推荐数',
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        browse: {
            $id: '$root/properties/browse',
            type: 'object',
            patternProperties: {
                '^.*$': { type: 'integer' },
            },
        },
    },
};

/* slide */
const recommendDataSchema = {
    $id: '$root',
    type: 'array',
    title: '幻灯获取最后一帧图集推荐',
    $schema: 'http://json-schema.org/draft-07/schema#',
    items: {
        $id: '$root/items',
        type: 'object',
        properties: {
            img: {
                $id: '$root/items/properties/img',
                type: 'string',
            },
            title: {
                $id: '$root/items/properties/title',
                type: 'string',
            },
            url: {
                $id: '$root/items/properties/url',
                type: 'string',
            },
            publishTime: {
                $id: '$root/items/properties/publishTime',
                type: 'string',
            },
        },
    },
};

export { commentCountSchema, voteNumSchema, recommendDataSchema };
